export const PeriodEnum = {
  ToDay: 1, // Hôm nay
  ThisWeek: 2, // Tuần này
  ThisMonth: 3, // Tháng này
  ThisQuarter: 4, // QUý này
  ThisYear: 5, // Năm nay
  LastDay: 6, // Hôm qua
  LastWeek: 7, // Tuần trước
  LastMonth: 8, // Tháng trước
  LastQuarter: 9, // QUý trước
  LastYear: 10, // Năm ngoái
  FistSixMonths: 11, // 6 tháng đầu năm
  LastSixMonths: 12, // 6 tháng cuối năm
  FourWeekAgo: 13, // 4 tuần gần đây
  ThisMonthVerWeek: 14, // Tháng này theo kỳ tuần
  LastMonthVerWeek: 15, // Tháng trước theo kỳ tuần
  OptionDate: 16, //Tùy chọn
  Tomorrow: 17, // Ngày mai
  NextWeek: 18, //Tuần sau
};
export const OverviewTypeTimeEnum = {
  Week: 1, // Tuần
  Month: 2, // Tháng
  Quarter: 3, // Quý
  Year: 4, //năm
};
export const StatisticsFollowSalaryEnum = {
  BasicSalary: 1, //Lương cơ bản
  RealIncome: 2, // Thực lĩnh
};
export const QuaterTextEnum = ["Quý I", "Quý II", "Quý III", "Quý IV"];
